export const COMPANY = {
  name: "Codeflare Labs",
  tagline: "Empowering the Future with Technology & Education",
  email: "contact@codeflarelabs.com",
  phone: "+91 6291074147",
  whatsapp: "916291074147",
  address: "Kolkata, West Bengal, India",
  founded: "2025",
  logo: "https://customer-assets.emergentagent.com/job_d7c8755f-0600-4e31-ac24-ad7b750563dd/artifacts/h738p37q_Codeflare%20Labs%20Logo.svg",
};

export const SERVICES = [
  {
    key: "web", title: "Website Development", icon: "Globe",
    desc: "Lightning-fast, SEO-rich websites built with modern stacks.",
    long: "We build production-grade websites that load fast, rank well and convert. Marketing sites, web apps, dashboards, portals — we have shipped them all for clients across India and abroad.",
    deliverables: ["Marketing & corporate websites", "Web apps & dashboards", "Headless CMS portals", "Landing-page funnels", "Multi-language sites"],
    tech: ["Next.js / React / Astro", "Tailwind / CSS-in-JS", "Headless CMS (Sanity / Strapi)", "Vercel / Cloudflare", "GA / GTM analytics"],
    bullets: ["Lighthouse 95+ scores", "SEO architecture from day one", "CMS so your team can edit"],
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "mobile", title: "Mobile App Development", icon: "Smartphone",
    desc: "Native & cross-platform apps for iOS and Android.",
    long: "Whether it is Flutter, React Native or fully native — we ship beautiful, performant apps with payments, analytics, push, deep-links and offline-first sync built in.",
    deliverables: ["iOS + Android cross-platform apps", "Native performance modules", "In-app payments (Razorpay / Stripe)", "Push notifications & deep-links", "App-store submission & reviews"],
    tech: ["Flutter / Dart", "React Native", "Swift / Kotlin", "Firebase", "Sentry / Crashlytics"],
    bullets: ["1 codebase, both stores", "Offline-first sync", "App Store + Play Store launch handled"],
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "marketing", title: "Digital Marketing", icon: "Megaphone",
    desc: "SEO, paid ads, social campaigns that convert.",
    long: "Performance marketing built on data. We run SEO, paid ads and social campaigns with weekly reports and ROI tracked end to end.",
    deliverables: ["SEO audits & content strategy", "Google / Meta / LinkedIn ads", "Social media management", "Email & WhatsApp campaigns", "Conversion-rate optimisation"],
    tech: ["Google Analytics 4 / GTM", "Meta Business Suite", "SEMrush / Ahrefs", "HubSpot / Mailchimp", "Hotjar"],
    bullets: ["Weekly performance reports", "Tracked ROI on every campaign", "Conversion-focused creatives"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "ecommerce", title: "Ecommerce Website", icon: "ShoppingCart",
    desc: "High-converting storefronts with payments & analytics.",
    long: "From a single-brand DTC store to multi-vendor marketplaces — we build, integrate and scale your ecommerce engine with payments, logistics, ERP and analytics.",
    deliverables: ["Single-brand DTC stores", "Multi-vendor marketplaces", "Payment gateway integrations", "Logistics & courier APIs", "Inventory + ERP sync"],
    tech: ["Shopify / WooCommerce", "Magento / Custom Next.js", "Razorpay / Stripe", "Shiprocket / Delhivery", "Algolia search"],
    bullets: ["Average 30% checkout-conversion lift", "Multi-currency & GST", "Logistics partners pre-integrated"],
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "crm", title: "CRM & ERP", icon: "Database",
    desc: "Custom CRMs and ERPs tailored to your workflows.",
    long: "Tired of bending your business to off-the-shelf software? We build CRMs and ERPs that match your exact workflow — sales, HR, inventory, finance, vendor management and reports under one roof.",
    deliverables: ["Custom sales pipelines", "HR + payroll modules", "Inventory & multi-warehouse", "Vendor & procurement", "BI dashboards & reports"],
    tech: ["FastAPI / Node.js", "PostgreSQL / Mongo", "Metabase / Superset", "Zapier / n8n integrations", "Role-based access"],
    bullets: ["Built around your exact process", "GST + e-invoice ready", "Mobile-friendly admin"],
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "ai", title: "AI Automation", icon: "Sparkles",
    desc: "Agentic workflows, RAG, and AI-powered ops.",
    long: "We design and ship AI automations that save hundreds of hours: agents that draft replies, RAG over your private docs, voice bots, and end-to-end workflow automations.",
    deliverables: ["RAG over private knowledge", "Agentic workflow automation", "AI-powered customer support", "Document & invoice extraction", "Voice & WhatsApp bots"],
    tech: ["OpenAI / Claude / Gemini", "LangChain / LlamaIndex", "Pinecone / Qdrant", "Whisper STT / TTS", "n8n / Make"],
    bullets: ["10x faster ops with AI", "Private models, your data stays yours", "Cost-tracked LLM usage"],
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "consult", title: "IT Consulting", icon: "Briefcase",
    desc: "Strategy, architecture and tech roadmap audits.",
    long: "Stuck on architecture, hiring or scaling? Our senior engineers review your stack, roadmap, hiring plan and product strategy — delivered as actionable docs.",
    deliverables: ["Architecture & cloud audits", "Tech-stack selection", "Hiring & team scaling plans", "Product strategy reviews", "DevOps & cost optimisation"],
    tech: ["AWS / GCP / Azure", "Terraform / Kubernetes", "GitHub Actions / GitLab CI", "Datadog / New Relic", "Snyk / SonarCloud"],
    bullets: ["Senior-only consultants", "Actionable deliverables", "Founder-friendly pricing"],
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "block", title: "Blockchain Development", icon: "Boxes",
    desc: "Smart contracts, DApps and Web3 integrations.",
    long: "From smart contracts to wallets, DEX integrations and token launches — we ship audited, gas-optimised Web3 products on the major chains.",
    deliverables: ["Smart contract development", "DApps & wallets", "Token launches & DEX integration", "On/off-ramp integration", "Audits & security review"],
    tech: ["Solidity / Move", "Hardhat / Foundry", "Wagmi / RainbowKit", "Ethers.js", "Slither / Mythril"],
    bullets: ["Audited, gas-optimised", "Mainnet & L2 ready", "Multi-chain support"],
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "custom", title: "Custom Software", icon: "Code2",
    desc: "Bespoke software engineered for your domain.",
    long: "When off-the-shelf does not cut it, we engineer custom software that fits your exact domain — from logistics platforms to medical workflow tools.",
    deliverables: ["Logistics & supply-chain platforms", "Medical & legal workflows", "Real-estate & rental tools", "Internal admin tools", "Legacy modernisation"],
    tech: ["Microservices on FastAPI / Go", "Kafka / RabbitMQ", "PostgreSQL / Redis", "Docker / Kubernetes", "Sentry / Grafana"],
    bullets: ["Domain-deep engineering", "Built to scale 100x", "Long-term support contracts"],
    image: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "telesales", title: "Telesales Services", icon: "PhoneOutgoing",
    desc: "Outbound sales teams that hit your targets.",
    long: "Outbound sales-as-a-service — trained agents, your scripts, our dialer. Daily reporting, QA-rated calls and CRM-integrated.",
    deliverables: ["B2B & B2C outbound teams", "CRM-integrated dialer", "Daily reporting & QA", "Lead qualification & scoring", "Multi-language calling"],
    tech: ["Custom dialer", "WhatsApp Business API", "CRM (Codeflare CRM / HubSpot)", "Call recording + QA", "Real-time dashboards"],
    bullets: ["Agents you can hand-pick", "QA-rated calls", "Pay per qualified lead option"],
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80",
  },
  {
    key: "support", title: "Tele Caller Support", icon: "Headphones",
    desc: "Inbound support that delights your customers.",
    long: "24×7 inbound desks for support, helplines and customer success. Bengali, Hindi, English and more.",
    deliverables: ["24×7 inbound support desks", "Multilingual agents", "Tickets, chat & calls", "WhatsApp customer support", "Helpline numbers"],
    tech: ["Helpdesk (Freshdesk / custom)", "Telephony (Exotel / Twilio)", "WhatsApp Business API", "Knowledge base", "Analytics dashboards"],
    bullets: ["Bengali, Hindi, English ready", "<2 min average response", "CSAT-tracked agents"],
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1600&q=80",
  },
];

export const FOUNDERS = [
  {
    name: "Akash Sarkar",
    role: "Founder & CEO",
    bio: "Visionary technologist driving Codeflare Labs' mission to bridge education and real-world software.",
    photo: "https://customer-assets.emergentagent.com/job_techbridge-pro/artifacts/1e1qf462_Akash%20Sarkar.jpeg",
  },
  {
    name: "Arnab Bera",
    role: "Co-Founder & COO",
    bio: "Operations leader scaling delivery for 50+ international clients with relentless quality focus.",
    photo: "https://customer-assets.emergentagent.com/job_techbridge-pro/artifacts/47qzi80i_Arnab%20Bera.PNG",
  },
];

// Software/dev focused hero — engineers building software, mobile and web
export const HERO_BG = "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?auto=format&fit=crop&w=2000&q=80";

// Software-development hero photo (replaces previous KMC visual)
export const KMC_BG = "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=2000&q=80";

// About-page work photos (software development, code, mobile, team)
export const ABOUT_GALLERY = [
  { src: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1200&q=80", caption: "Building production-grade software" },
  { src: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80", caption: "Collaborating with global clients" },
  { src: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=1200&q=80", caption: "Mobile apps that ship" },
  { src: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80", caption: "Training the next-gen engineers" },
  { src: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80", caption: "Strategy & architecture sessions" },
  { src: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80", caption: "Ecommerce & ERP delivery" },
];
